import {Component, OnInit} from '@angular/core';
import {securityCodeForm} from '../../../Assets/angular/assets/data/forms/security_code_form';

@Component({
    selector: 'app-security-code-form',
    templateUrl: './security-code-form.component.html',
    styleUrls: ['./security-code-form.component.scss']
})
export class SecurityCodeFormComponent implements OnInit {

    securityCodeForm: Array<object>;

    constructor() {
        this.securityCodeForm = securityCodeForm;
    }

    ngOnInit(): void {
    }

}
